import { connect } from 'react-redux';
import CRUDAction from '../../../actions/event';
import EventsNew from './EventsNew';

export default connect(
  ({ event: { model } }) => ({
    loading: false,
    title: 'Create Event',
    isNew: model ? model.isNew() : true
  }),
  dispatch => ({
    init: () => dispatch(CRUDAction.createModel())
  })
)(EventsNew);





// WEBPACK FOOTER //
// ./src/components/Events/EventsNew/index.js